import { useState, useEffect } from 'react';
// import { v4 as uuidv4 } from 'uuid';
import SecureLS from 'secure-ls';

import { getUUID as uuidv4 } from '../utils/getUUID';

export const useSecureDeviceId = () => {
  const [deviceId, setDeviceId] = useState<string | null>(null);

  useEffect(() => {
    const ls = new SecureLS({ encodingType: 'aes', isCompression: false });

    const deviceId = localStorage.getItem('deviceId');
    let storedId: string | null;

    if (deviceId) {
      try {
        storedId = ls.get('deviceId');
        setDeviceId(storedId);
      } catch {
        localStorage.removeItem('deviceId');
        const newDeviceId = uuidv4();
        ls.set('deviceId', newDeviceId);
        storedId = newDeviceId;
        setDeviceId(storedId);
      }
    } else {
      if (!deviceId) {
        const newDeviceId = uuidv4();
        ls.set('deviceId', newDeviceId);
        storedId = newDeviceId;
        setDeviceId(storedId);
      }
    }
  }, []);

  return deviceId;
};
